/**
 * SystmOneService - status of the user's SystmOne bridge for the selected clinic
 */
export class SystmOneService {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * @returns {Promise<{registered: boolean, active: boolean, reason: string, lastSeen: string|null,
   *   systmOneUserName: string|null, bridgeVersion: string|null}>}
   */
  async fetchBridgeStatus() {
    return this.apiClient.get('/api/systmone/bridge/status');
  }
}
